<template>
	<div id="outstandingitemsreport" v-loading="loading">
		<div class="row">
			<div class="col-12 fullpage">
				<h5>Automations - {{OutstandingAutomations.length}}</h5>
			</div>
		</div>
		<div class="row mt-1">
			<div class="col-12 fullpage">
				<el-table v-if="OutstandingAutomations.length > 0"
						  stripe
						  :data="OutstandingAutomations"
						  style="width: 100%"
						  size="small"
						  max-height="600">
					<el-table-column
							prop="GameChangeID"
							label="ID"
							width="75px"
							align="center">
							<template #default="scope">
								<a href="/schedulemanagement">{{scope.row.GameChangeID}}</a>
							</template>
					</el-table-column>
					<el-table-column
							prop="ChangeType"
							label="Type"
							width="120px"
							align="center">
							<template #default="scope">
								<span v-html="String(scope.row.ChangeType[0]).toUpperCase() + String(scope.row.ChangeType).slice(1)"></span>
							</template>
					</el-table-column>
					<el-table-column
							label="Original Game"
							min-width="200px">
						<template #default="scope">
							<div v-html="scope.row.HomeFromTeamName + ' vs ' + scope.row.VisitingFromTeamName"></div>
							<div v-html="scope.row.FromGameDateF + ' - ' + scope.row.FromLocationName + ' @ ' + scope.row.FromStartTime"></div>
						</template>
					</el-table-column>
					<el-table-column
							label="Changes"
							min-width="150px">
						<template #default="scope">
							<div v-if="scope.row.ToGameID > 0" v-html="scope.row.HomeToTeamName + ' vs ' + scope.row.VisitingToTeamName"></div>
							<div v-if="scope.row.ToGameLocationID > 0 && scope.row.FromGameLocationID != scope.row.ToGameLocationID" v-html="scope.row.ToGameDateF + ' - ' + scope.row.ToLocationName + ' @ ' + scope.row.ToStartTime"></div>
							<div v-else v-html="scope.row.StatusCodeName"></div>
						</template>
					</el-table-column>
					<el-table-column
							prop="outstandingTeams"
							label="Outstanding"
							min-width="150px"
							align="left">
					</el-table-column>
					<el-table-column
							prop="createdby"
							label="Admin"
							width="120px"
							align="left">
					</el-table-column>
					<el-table-column
							prop="createdwhen"
							label="Timestamp"
							width="140px"
							align="center">
					</el-table-column>
				</el-table>
				<div v-else v-html="'No Outstanding Automations'"></div>
			</div>
		</div>
		<div class="row mt-4">
			<div class="col-12 fullpage">
				<h5>{{config.Params.game}} Cancellations - <span v-html="(OutstandingGameCancellations.length + OutstandingGameCancellationsNoUsage.length)"></span></h5>
				<el-radio-group class="mt-2 mb-2"  v-model="CancellationType" size="small">
					<el-radio-button value="m">Missing Response</el-radio-button>
					<el-radio-button value="u">No Usage</el-radio-button>
				</el-radio-group>
			</div>
		</div>
		<div class="row mt-1">
			<div class="col-12 fullpage">
				<el-table v-if="OutstandingGameCancellations.length > 0"
						  stripe
						  :data="(CancellationType == 'm' ? OutstandingGameCancellations : OutstandingGameCancellationsNoUsage)"
						  style="width: 100%"
						  size="small"
						  max-height="600">
					<el-table-column
							prop="GameDateTime"
							label="Date Time"
							width="120px"
							align="left"
					>
					</el-table-column>
					<el-table-column
							prop="LocationName"
							label="Game/Location"
							min-width="130px"
							sortable>
						<template #default="scope">
							<div v-html="'<b>' + scope.row.GameDesc + '</b>'+ '<br>' + scope.row.LocationName "></div>
						</template>
					</el-table-column>
					<el-table-column
							prop="submittedwhen"
							label="Submission"
							min-width="130px"
						>
                        <template #default="scope">
                            <div v-if="scope.row.Params" v-html="scope.row.Params.FirstName + ' ' + scope.row.Params.LastName + '<br>' + scope.row.Params.EmailAddress + '<br>' + scope.row.submittedwhen"></div>
                        </template>
					</el-table-column>
					<el-table-column
							prop="SubmitterTeamName"
							label="Submitting Team"
							min-width="120px">
					</el-table-column>
					<el-table-column
							prop="WhoCancelled"
							label="Who Cancelled"
							min-width="120px">
                        <template #default="scope">
                            <div v-if="scope.row.Params" v-html="(scope.row.WhoCancelled == 'Both teams' ? 'Both teams' : (scope.row.WhoCancelled == 'My team' ? (scope.row.Params.TeamID == scope.row.HomeTeamID ? scope.row.HomeTeamName : scope.row.VisitingTeamName) : (scope.row.Params.TeamID == scope.row.HomeTeamID ? scope.row.VisitingTeamName : scope.row.HomeTeamName)))"></div>
                        </template>
					</el-table-column>
					<el-table-column
							prop="MyTeamUsage"
							label="Submitting Team Usage"
							width="130px">
					</el-table-column>
					<el-table-column
						v-if="CancellationType !== 'm'"
							prop="OtherTeamUsage"
							column-key="OtherTeamUsage"
							label="Other Team Usage"
							width="130px">
						<template #default="scope">
							<template v-if="scope.row.operation == 'update'">
								<el-select style="width: 100%;min-height: 30px;" v-model="scope.row.OtherTeamUsage" placeholder="Select" size="small" default-first-option filterable clearable >
									<el-option
											v-for="item in teamUsage"
											:key="item"
											:label="item"
											:value="item">
									</el-option>
								</el-select>
							</template>
							<span v-else v-html="scope.row.OtherTeamUsage"></span>
						</template>
					</el-table-column>
					<el-table-column
						v-if="CancellationType !== 'm'"
                        prop="Params.ReasonUsage"
                        label="Email Responses"
                        align="left"
                        white-space = "nowrap"
                        min-width="240px">
                        <template #default="scope">
                            <div v-if="scope.row.Params && scope.row.Params.ResponseUsage">
                                <div v-for="(time, index) in scope.row.Params.ResponseTime">
                                    <div class="responsetime">Time: {{time}}</div>
                                    <div class="responseusage">Usage: {{scope.row.Params.ResponseUsage[index]}}</div>
                                    <div class="responseemailaddress">Who: {{scope.row.Params.ResponseEmailAddress[index]}}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
							prop="Params.Reason"
							label="Reason"
							align="left"
							white-space = "nowrap"
							min-width="240px">
					</el-table-column>
				</el-table>
				<div v-else v-html="'No Outstanding ' + config.Params.games+ ' Cancellation Responses'"></div>
			</div>
		</div>
		<div class="row mt-4">
			<div class="col-12 fullpage">
				<h5>{{config.Params.games}} Requiring Scores to be Entered - {{OutstandingGames.length}}</h5>
			</div>
		</div>
		<div class="row mt-1">
			<div class="col-12 fullpage">
				<el-table v-if="OutstandingGames.length > 0"
						  stripe
						  :data="OutstandingGames"
						  style="width: 100%"
						  size="small"
						  max-height="600">
					<el-table-column
							label="Date"
							width="120px"
							align="left"
					>
						<template #default="scope">
							<div v-html="scope.row.GameDateF"></div>
						</template>
					</el-table-column>
					<el-table-column
							label="Start Time"
							width="120px"
							align="left"
					>
						<template #default="scope">
							<div v-html="scope.row.StartTime"></div>
						</template>
					</el-table-column>
					<el-table-column
							prop="LeagueName"
							label="League"
							min-width="100px"
							sortable>
					</el-table-column>
					<el-table-column
							prop="LocationName"
							label="Location"
							min-width="100px"
							sortable>
					</el-table-column>
					<el-table-column
							prop="DivisionName"
							label="Division"
							column-key="DivisionName"
							align="left"
							min-width="130px"
							sortable
					>
					</el-table-column>
					<el-table-column
							prop="HomeTeamName"
							label="Home"
							column-key="HomeTeamName"
							align="left"
							min-width="130px"
					>
					</el-table-column>
					<el-table-column
							prop="VisitingTeamName"
							label="Away"
							column-key="VisitingTeamName"
							align="left"
							min-width="130px"
					>
					</el-table-column>
				</el-table>
				<div v-else v-html="'No ' + config.Params.games + ' needing Scores to be Reported'"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

	export default {
		name: 'OutstandingItems',
		data() {
			return {
				loading : true,
                currentStatus : STATUS_INITIAL,
				search: '',
				OutstandingAutomations : [],
				OutstandingGameCancellations : [],
				OutstandingGameCancellationsNoUsage : [],
				OutstandingGames : [],
				CancellationType : 'm'
			}
		},
		props:["config", "parentrefs"],

		methods: {
			getOutstandingItems () {
				this.loading = true;
				this.OutstandingAutomations = [];
				axios.post('/notifications/getoutstandingitems', {},
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.OutstandingAutomations = response.data.OutstandingAutomations;
							this.OutstandingGameCancellations = response.data.OutstandingGameCancellations;
							this.OutstandingGameCancellationsNoUsage = response.data.OutstandingGameCancellationsNoUsage;
							this.OutstandingGames = response.data.OutstandingGames;
						}
						this.loading = false;
					}).catch(response => {
						this.loading = false;
				});
			},
            markReply(row) {
                this.currentStatus = STATUS_SAVING;
                this.$startProgressBar(this.parentrefs);
                axios.post('/notifications/markreply', {Notification : row },
                )
                    .then(response => {
                        if (response.data.result == 'success') {
                            this.currentStatus = STATUS_INITIAL;
                            this.$stopProgressBar(this.parentrefs);
                            this.$notify({
                                title: 'Success',
                                message: "This Notification has been marked as replied to.",
                                type: 'success',
                                duration: 2000,
                                showClose: false
                            });
                            for (let i = 0; i < this.OutstandingItems.length; i++) {
                                if (this.OutstandingItems[i].NotificationID == row.NotificationID) {
                                    this.OutstandingItems[i] = response.data.Notification;
                                    break;
                                }
                            }
                        } else {
                            this.currentStatus = STATUS_FAILED;
                            this.displayPopup (response.data.message);
                            this.$failProgressBar(this.parentrefs);
                        }
                    }).catch(response => {
                    this.currentStatus = STATUS_FAILED;
                    this.$failProgressBar(this.parentrefs);
                });
            },
			gotoLink (link) {
				this.$router.replace(link);
			},
		},
		mounted () {
			this.getOutstandingItems ();
		}
	}
</script>

<style>
    #outstandingitemsreport .el-table--mini td, .el-table--mini th {
        padding: 3px 0;
    }
</style>
<style scoped>
	#app #outstandingitemsreport h5 {
		font-weight: 800;
	}
	.messageReply {
		border: 1px solid #ccc;
		border-radius: 4px;
		padding: 5px;
		background-color: #fff;
		line-height: 16px;
	}
	.messageReply br {
		height: 2px;
	}
	#app #outstandingitemsreport button.btn.circle i, #app #outstandingitemsreport button.el-button.circle i {
		margin : 0;
	}
</style>
